module.exports = __webpack_public_path__ + "static/media/taxid.f4417ee8.png";